import { GlobalAppState } from '@model/state';

export const getTourRooms = (state: GlobalAppState) => state.tours.tourRooms;
export const getTourRoomOptions = (state: GlobalAppState) => state.tours.tourRooms.hotels;
export const getTourRoomsLoading = (state: GlobalAppState) => state.tours.tourRooms.loading;
export const getTourRoomsError = (state: GlobalAppState) => state.tours.tourRooms.error;
